package com.anjuros.website.templates.template2.modules


import com.anjuros.website.templates.template2.util.ResKey

enum class Template2Service(
    val image: String,
    val title: ResKey,
    val description: ResKey
) {

    PLUMBING(
        image = "template2service1.jpg",
        title = ResKey.TEMPLATE2_SERVICE1_TITLE,
        description = ResKey.TEMPLATE2_SERVICE1_DESC1
    ),

    ELECTRICS(
        image = "template6-main.webp",
        title = ResKey.TEMPLATE2_SERVICE2_TITLE,
        description = ResKey.TEMPLATE2_SERVICE2_DESC1
    ),

    TILING(
        image = "template2service3.jpg",
        title = ResKey.TEMPLATE2_SERVICE3_TITLE,
        description = ResKey.TEMPLATE2_SERVICE3_DESC1
    ),

    CARPENTRY(
        image = "template2service4.jpg",
        title = ResKey.TEMPLATE2_SERVICE4_TITLE,
        description = ResKey.TEMPLATE2_SERVICE4_DESC1
    ),

    MAINTENANCE(
        image = "template2service5.jpg",
        title = ResKey.TEMPLATE2_SERVICE5_TITLE,
        description = ResKey.TEMPLATE2_SERVICE5_DESC1
    ),

    REPAIRS(
        image = "template2service6.jpg",
        title = ResKey.TEMPLATE2_SERVICE6_TITLE,
        description = ResKey.TEMPLATE2_SERVICE6_DESC1
    )

}